// extracted by mini-css-extract-plugin
export var assigneeBadge = "_lg-0";
export var assigneeDetails = "_lg-1";
export var assigneeInfo = "_lg-2";
export var dropdownContainer = "_lg-4";
export var dropdownImage = "_lg-5";
export var editAssigneeInfo = "_lg-3";
export var editAssigneeModalContainer = "_lg-6";
export var hidden = "_lg-8";
export var input = "_lg-7";